export default "__VITE_ASSET__SWhGv2wX__"